export const UPLOAD_FILE = "ATTACHMENT/UPLOAD_FILE_REQUEST";
export const UPLOAD_PROGRESS = "ATTACHMENT/UPLOAD_FILE_PROGRESS";
export const SUCCESS_UPLOAD = "ATTACHMENT/UPLOAD_FILE_SUCCESS";
export const FAILURE_UPLOAD = "ATTACHMENT/UPLOAD_FILE_FAILURE";
export const RETRY_UPLOAD = "ATTACHMENT/UPLOAD_FILE_RETRY";
export const REMOVE_FILE = "ATTACHMENT/DELETE_FILE";
export const CLEAR_FILE = "ATTACHMENT/CLEAR_FILE";
